import { CHANGE_STATUS, DELETE_USER, SET_USER, CHANGE_MEMBERSHIP, ADD_USER, COURSE_UNENROLL, EDIT_USER } from "../constants";

export const deleteUserById = (payload) => (
    {
        type: DELETE_USER,
        payload: payload
    }
);

export const changeStatus = (payload) => (
    {
        type: CHANGE_STATUS,
        payload: payload
    }
);

export const changeMemberShip = (payload) => (
    {
        type: CHANGE_MEMBERSHIP,
        payload: payload
    }
);

export const setUser = (payload) => (
    {
        type: SET_USER,
        payload: payload
    }
);

export const addUser = (payload) => (
    {
        type: ADD_USER,
        payload: payload
    }
);

export const editSkillUser = (payload) => ({
    type: EDIT_USER,
    payload: payload,
  });
  

export const courseUnenroll = (payload) => (
    {
        type: COURSE_UNENROLL,
        payload: payload
    }
);